export const GET_FEES_BY_FACILITY = 'fees/GET_FEES_BY_FACILITY'
export const EDIT_FEES = 'fees/EDIT_FEES'
export const DELETE_FEES = 'fees/DELETE_FEES'
export const CHANGE_FEES_FOR_FACILITY = 'fees/CHANGE_FEES_FOR_FACILITY'
export const RESET_FACILITY_FEES = 'fees/RESET_FACILITY_FEES'
export const GET_SCHEDULER = 'fees/GET_SCHEDULER'
export const GET_ALL_FEES = 'fees/GET_ALL_FEES'
export const START_LOADING_ALL_FEES = 'fees/START_LOADING_ALL_FEES'
export const STOP_LOADING_ALL_FEES = 'fees/STOP_LOADING_ALL_FEES' 
